import { createFileRoute } from '@tanstack/react-router';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { CustomersPage } from '@web/modules/customers/list/customers-page';
import { parseCustomerListSearch } from '@web/modules/customers/list/list-search';
import { QuickCreateDialog } from '@web/modules/customers/quick-create/quick-create-dialog';
import { parseImportSearch, withoutImport } from '@web/modules/imports/import-search';
import { parseCreateSearch, withoutCreate } from '@web/shared/util/create-search';
import { ImportDrawer } from '@web/modules/imports/wizard/import-drawer';
import { toast } from '@web/shared/ui/toast';

export const Route = createFileRoute('/_app/customers/')({
  // `?import=customers` opens the import drawer over the list (spec 007 §7.2).
  validateSearch: (search: Record<string, unknown>) => ({
    ...parseCustomerListSearch(search),
    ...parseImportSearch(search, 'customers'),
    ...parseCreateSearch(search),
  }),
  component: CustomersRoute,
});

function CustomersRoute() {
  const { t } = useTranslation();
  const routeSearch = Route.useSearch();
  const search = withoutCreate(withoutImport(routeSearch));
  const navigate = Route.useNavigate();
  const [creating, setCreating] = useState(false);
  return (
    <>
      <CustomersPage
        search={search}
        onSearchChange={(next, options) =>
          void navigate({ search: next, replace: options?.replace })
        }
        onNewCustomer={() => setCreating(true)}
        onImport={() => void navigate({ search: { ...search, import: 'customers' } })}
      />
      <ImportDrawer
        entity="customers"
        open={routeSearch.import === 'customers'}
        onClose={() => void navigate({ search })}
      />
      <QuickCreateDialog
        open={creating || routeSearch.new === true}
        onOpenChange={(next) => {
          setCreating(next);
          if (!next && routeSearch.new) void navigate({ search });
        }}
        onCreated={(customer) => {
          setCreating(false);
          toast.success({
            title: t('customers.quickCreate.created', { name: customer.displayName }),
          });
          void navigate({
            to: '/customers/$customerId',
            params: { customerId: customer.id },
            search: { created: true },
          });
        }}
      />
    </>
  );
}
